import React, { useEffect, useState } from 'react';
import { Drawer } from '@quillbot/design-system';
import { makeStyles } from '@quillbot/design-system';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { getDrawerItem } from 'src/_common/handlers/services';
import { toggleDrawerAction } from 'src/_common/actions/commonActions';
import DrawerHeader from './DrawerHeader';

const Drawrers = {
  FEEDBACK: 'Feedback',
  PPHR_STATISTICS: 'Statistics',
  HOTKEYS: 'Hotkeys',
  PPHR_SETTINGS: 'Settings',
  FREEZE_WORDS: '',
  COMPARE_MODE: 'Compare Modes',
  BILLING_HISTORY: 'Billing History',
  GC_SETTINGS: 'Settings',
  GC_STATISTICS: 'Statistics',
  SMZR_STATISTICS: 'Statistics',
};

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 'min(80vw,350px)',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: 'min(80vw,350px)',
    },
  },
  drawerWrapper: {
    zIndex: 1202,
  },
  drawerPaper: {
    width: '350px',
    maxWidth: '350px',
    padding: '15px',
    zIndex: 1202,
    [theme.breakpoints.down(438)]: {
      width: '80vw',
      maxWidth: '80vw',
    },

    // '& svg': {
    //   '&:hover': {
    //     color: theme.palette.primary.main,
    //   },
    // },

    '& button': {},
  },
  hidescrollForMsWordEXT: {
    overflowX: 'hidden',
  },
}));

type IDrawerState = 'persistent' | 'permanent' | 'temporary' | undefined;

interface IProps {
  controlBar?: React.ComponentType<any>;
}

function QuillDrawer(props: IProps) {
  const classes = useStyles();
  const drawerState = useSelector((store: RootState) => store.common);
  const dispatch = useDispatch();
  const [drawerVarient, setDrawerVarient] = useState<IDrawerState>('temporary');
  const Item = getDrawerItem();
  useEffect(() => {
    setDrawerVarient(window.innerWidth >= 1350 ? 'persistent' : 'temporary');
  }, [drawerState]);
  const drawerName = drawerState.quillDrawer ? Drawrers[drawerState.quillDrawer] : '';

  return (
    <Drawer
      classes={{
        paper: classes.drawerPaper,
        root: classes.drawerWrapper,
      }}
      anchor="right"
      variant={drawerVarient}
      open={drawerState && drawerState.quillDrawer != null}
      onClose={() => dispatch(toggleDrawerAction(null))}>
      <span
        className={`${
          drawerState?.platform?.isExtension &&
          drawerState?.platform?.isIE &&
          drawerState?.platform?.extensionMetaData?.type === 'ms-word' &&
          drawerName !== 'Feedback'
            ? classes.hidescrollForMsWordEXT
            : undefined
        }`}>
        <DrawerHeader name={drawerName} controls={props.controlBar} />
        {drawerState && drawerState.quillDrawer != null ? <Item /> : null}
      </span>
    </Drawer>
  );
}

export default QuillDrawer;
